import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { CircleAlert, TriangleAlert } from "lucide-react";
import { Button, Card, cx } from "@/components/ui";
import { api } from "@/lib/api";
import { fmtRelative } from "@/lib/format";

/** Logiful intern: offene Störungen (fehlgeschlagene Hintergrund-Jobs, gestörte Verbindungen) */
export function AlertsCard() {
  const qc = useQueryClient();
  const q = useQuery({ queryKey: ["alerts"], queryFn: api.admin.alerts, refetchInterval: 60_000 });
  const resolve = useMutation({ mutationFn: (id: string) => api.admin.resolveAlert(id), onSuccess: () => void qc.invalidateQueries({ queryKey: ["alerts"] }) });
  const open = (q.data ?? []).filter((a) => !a.resolvedAt);
  if (!open.length) return null;
  return (
    <Card className={cx("mb-4 overflow-hidden", open.some((a) => a.severity === "critical") ? "border-danger/40" : "border-warning/40")}>
      <div className="px-4 py-3 border-b border-border">
        <h2 className="font-semibold text-[14px] flex items-center gap-2"><TriangleAlert className="size-4 text-danger" /> {open.length === 1 ? "1 offene Störung" : `${open.length} offene Störungen`}</h2>
        <p className="text-[12.5px] text-fg-muted">Logiful-Admins bekommen dazu stündlich eine E-Mail, bis die Störung behoben ist. Ein erfolgreicher Lauf schließt sie automatisch.</p>
      </div>
      <ul className="divide-y divide-border">
        {open.map((a) => (
          <li key={a.id} className="px-4 py-2.5 flex items-start gap-3 text-[13px]">
            <CircleAlert className={cx("size-4 mt-0.5 shrink-0", a.severity === "critical" ? "text-danger" : "text-warning")} />
            <div className="min-w-0 flex-1">
              <p className="font-medium">{a.title}</p>
              {a.detail && <p className="text-[12px] text-fg-muted break-words">{a.detail}</p>}
              <p className="text-[11.5px] text-fg-subtle">seit {fmtRelative(a.firstAt)} · {a.count}× · zuletzt {fmtRelative(a.lastAt)}</p>
            </div>
            <Button size="sm" variant="ghost" loading={resolve.isPending && resolve.variables === a.id} onClick={() => resolve.mutate(a.id)}>Als erledigt markieren</Button>
          </li>
        ))}
      </ul>
    </Card>
  );
}
